import React from "react";
import Ratings from "react-star-ratings";
import { Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import Fonts from "../assets/Fonts";
import classes from "./CoachDetailsTestimonialsAndRatings.module.css";
import Colors from "../assets/Colors";

const ReviewsWithRating = ({ title, progress, rating }) => {
  return (
    <Row className={classes.reviewWithRatingContainer}>
      <Col md={2} sm={3} xs={4} >
        <span
          className={`${[classes.reviewTitle].join(" ")}`}
          style={{ color: Colors.neutralShadesOfNero, ...Fonts.p1 }}
        >
          {title}
        </span>
      </Col>
      <Col md={10} sm={9} xs={8} className={`${[classes.acenter].join(" ")}`}>
        <div
          className={`${[classes.progressContainer].join(" ")}`}
          style={{ backgroundColor: Colors.neutralShadesOfWhisper }}
        >
          <div
            className={`${[classes.progressLine].join(" ")}`}
            style={{
              width: progress,
              backgroundColor: Colors.mainShadeOfRed,
            }}
          />
        </div>
        <span
          className={`${[classes.value].join(" ")}`}
          style={{ color: Colors.neutralShadesOfNero, ...Fonts.h9 }}
        >
          {rating}
        </span>
      </Col>
    </Row>
  );
};

export const CoachDetailsTestimonialsAndRatings = ({ rating, totalReviews, reviewsTypes,heading }) => {
  return (
    <Row className={`my-3 ${[classes.reviews].join(" ")}`}>
      <Col md={12}>
        <div className={`${[classes.header].join(" ")}`}>
          <h4
            style={{
              color: Colors.neutralShadesOfNero,
              ...Fonts.h4,
              fontSize: "26px",
            }}
          >
            {heading ? heading : 'Reviews'}
          </h4>
          <div className={`${[classes.ratingsAndReviews].join(" ")}`}>
            <Ratings
              numberOfStars={1}
              starRatedColor={Colors.mainShadeOfRed}
              starEmptyColor={Colors.neutralShadesOfGainsboro}
              rating={rating}
              starDimension={"24px"}
              starSpacing={"4px"}
            />
            <span
              style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}
              className={`${[classes.rating].join(" ")}`}
            >
              {rating}
            </span>
          </div>
        </div>
      </Col>
      <Col md={12}>
        {reviewsTypes?.map((item) => {
          return (
            <ReviewsWithRating
              title={item?.title}
              rating={item?.rating}
              progress={item?.progress}
            />
          );
        })}
      </Col>
    </Row>
  );
};
CoachDetailsTestimonialsAndRatings.propTypes = {
  totalReviews: PropTypes.number,
  rating: PropTypes.number,
  reviewsTypes: PropTypes.array,
};
CoachDetailsTestimonialsAndRatings.defaultProps = {
  totalReviews: 12,
  rating: 3.2,
  reviewsTypes: [
    {
      title: "Accuracy",
      progress: "60%",
      rating: "4.0",
    },
    {
      title: "Location",
      progress: "100%",
      rating: "5.0",
    },
    {
      title: "Value",
      progress: "40%",
      rating: "3.0",
    },
    {
      title: "Communication",
      progress: "100%",
      rating: "5.0",
    },
  ],
};
